import registerAllComponents from '@shared/componentRenderer'
import '@shared/featherObserverService'
import SignIn from '../components/SignIn'
import StreamerKlipCues from '@components/Streamers/Shared/Klips/Cues'
import KlipCard from '@components/Streamers/Shared/Klips/Card'
import Toast from '@components/Shared/Toast'
import '@hotwired/turbo-rails'

const componentRegistry = {
  'signin': SignIn,
  'streamer-klip-cues': StreamerKlipCues,
  'klip-card': KlipCard,
  'toast': Toast,
}

registerAllComponents(componentRegistry)